export const CONTENT_LAYOUT_TITLE_DEFAULT = 'Подберите свой объект';
export const CONTENT_LAYOUT_SUBTITLE_DEFAULT = 'Чтобы быстрее найти подходящие объекты, укажите больше параметров';

export const CONTENT_LAYOUT_TITLE = 'Заполните эту форму';
export const CONTENT_LAYOUT_SUBTITLES = [
  'Чтобы получать обновления по новым подходящим объявлениям и сохранять поиски',
  'Чтобы скрывать неподходящие объявления и исключать дубли объявлений в выдаче',
  'Чтобы добавлять в избранное и создавать собственные подборки объектов',
];
